import React from 'react';
import Loadable from 'react-loadable';

const LoadableWidget = Loadable({
  loader: () => import(/* webpackChunkName: "HelpCenterSearchWidget" */ './HelpCenterSearchWidget'),
  modules: ['./HelpCenterSearchWidget'],
  loading: () => <div />
});

export default LoadableWidget;
